import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import {FinancePayoutCebuanaComponent} from 'app/finance';
import {MessageService} from 'primeng/api';
import {CebuanaPayoutTransactionService} from 'app/services/cebuana-payout-transaction.service';

@Component({
    selector: 'finance-payout-upload',
    templateUrl: './finance-payout-upload.component.html',
    styleUrls: ['./finance-payout-upload.component.scss',
        '../../../../../styles/style-layout.scss']
})

export class FinancePayoutUploadComponent implements OnInit {

    @Input()
    public menuPermissionActive!: string;

    @Input()
    public financePayoutComponent!: FinancePayoutCebuanaComponent;

    @Input()
    public visibleTransactionsFilter: boolean = false;

    @Output() changedVisibleHomeTransactionsFilterEmit = new EventEmitter<{ increased: boolean; reason: string }>();

    @Input()
    public filterObj: any = {};

    constructor(
        private messageService: MessageService,
        private cebuanaPayoutTransactionService: CebuanaPayoutTransactionService
    ) {
    }

    ngOnInit(): void {
    }

    clear() {
        this.filterObj = {};
    }

    clickFilter() {
        this.financePayoutComponent.filterObj = this.filterObj;
        this.financePayoutComponent.callPayoutTransactions(0);
        this.cancel();
    }

    handleInputClick(id: string): void {
        document.getElementById(id)?.click();
    }

    cancel(reason: string = '') {
        this.changedVisibleHomeTransactionsFilterEmit.emit({ increased: false, reason });
    }

    handleXlsChange(event: Event) {
        const target = event.target as HTMLInputElement;

        let file: File | null = null;

        if (target.files) {
            file = target.files[0];
        }

        if (!file) {
            return;
        }

        const formData = new FormData();
        formData.append('file', file);

        this.cebuanaPayoutTransactionService.uploadUpdatedStatusXls(formData, this.messageService)
            .then(data => {
                if (!data.Success) {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }
                this.cancel('Successfully uploaded excel');
            });
    }
}

